module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    创建工单\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "work-order-add-title"
  }, [_vm._v("工单信息")]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "5em"
    }
  }, [_c('popup-picker', {
    attrs: {
      "title": "问题所属类别",
      "data": _vm.list1
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [_c('span', {
          class: props.labelClass,
          staticStyle: {
            "height": "24px"
          },
          style: (props.labelStyle)
        }, [_c('span', {
          staticStyle: {
            "vertical-align": "middle"
          }
        }, [_vm._v("问题类别")])])]
      }
    }]),
    model: {
      value: (_vm.value1_1),
      callback: function($$v) {
        _vm.value1_1 = $$v
      },
      expression: "value1_1"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "placeholder": "请描述您的问题（必填）",
      "max": 200,
      "show-counter": false,
      "height": 80,
      "rows": 8,
      "cols": 30
    },
    model: {
      value: (_vm.describe),
      callback: function($$v) {
        _vm.describe = $$v
      },
      expression: "describe"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "update-imgs clearfix",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgnum < 3),
      expression: "imgnum<3"
    }],
    staticClass: "update-btn",
    staticStyle: {
      "position": "relative",
      "margin-right": "0.1rem"
    },
    attrs: {
      "id": "updateBtn"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgnum < 3),
      expression: "imgnum<3"
    }],
    staticClass: "moxie-shim moxie-shim-html5",
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "left": "28px",
      "width": "112px",
      "height": "112px",
      "overflow": "hidden",
      "z-index": "0"
    }
  }, [_c('input', {
    ref: "inputer",
    staticStyle: {
      "font-size": "999px",
      "opacity": "0",
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/gif"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgnum > 0),
      expression: "imgnum>0"
    }],
    staticClass: "col-img-item",
    attrs: {
      "src": _vm.dataUrl[0],
      "width": "100",
      "height": "100"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgnum > 1),
      expression: "imgnum>1"
    }],
    staticClass: "col-img-item",
    attrs: {
      "src": _vm.dataUrl[1],
      "width": "100",
      "height": "100"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgnum > 2),
      expression: "imgnum>2"
    }],
    staticClass: "col-img-item",
    attrs: {
      "src": _vm.dataUrl[2],
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value1_1[0] === '云服务器'),
      expression: "value1_1[0] === '云服务器'"
    }],
    attrs: {
      "label-width": "6em",
      "title": "云服务器IP",
      "placeholder": "请输入云服务器IP"
    },
    model: {
      value: (_vm.vps),
      callback: function($$v) {
        _vm.vps = $$v
      },
      expression: "vps"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value1_1[0] === '云服务器'),
      expression: "value1_1[0] === '云服务器'"
    }],
    attrs: {
      "label-width": "6em",
      "title": "管理员密码",
      "placeholder": "请输入管理员密码"
    },
    model: {
      value: (_vm.vps_psd),
      callback: function($$v) {
        _vm.vps_psd = $$v
      },
      expression: "vps_psd"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value1_1[0] === '域名'),
      expression: "value1_1[0] === '域名'"
    }],
    attrs: {
      "label-width": "6em",
      "title": "域名",
      "placeholder": "请输入域名"
    },
    model: {
      value: (_vm.domain),
      callback: function($$v) {
        _vm.domain = $$v
      },
      expression: "domain"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value1_1[0] === '虚拟主机'),
      expression: "value1_1[0] === '虚拟主机'"
    }],
    attrs: {
      "label-width": "6em",
      "title": "FTP帐号",
      "placeholder": "请输入FTP帐号"
    },
    model: {
      value: (_vm.vhost),
      callback: function($$v) {
        _vm.vhost = $$v
      },
      expression: "vhost"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value1_1[0] === '虚拟主机'),
      expression: "value1_1[0] === '虚拟主机'"
    }],
    attrs: {
      "label-width": "6em",
      "title": "FTP密码",
      "placeholder": "请输入FTP密码"
    },
    model: {
      value: (_vm.vhost_psd),
      callback: function($$v) {
        _vm.vhost_psd = $$v
      },
      expression: "vhost_psd"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "1rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("提交工单")]), _vm._v(" "), _c('div', [_c('loading', {
    attrs: {
      "text": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569553d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/workoradd.vue
// module id = y6a/
// module chunks = 1